import renderWidget from './d3charts';
import convertToGenII from './highcharts';

var tadaCharts = {
    highCharts: convertToGenII,
    d3Charts: renderWidget
};

export default tadaCharts;